import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Truck } from 'lucide-react';
import { Button, Input } from '@/components/ui';
import { useAuth } from '@/store/auth';
import { toast } from 'sonner';

export default function LoginPage() {
  const nav = useNavigate();
  const { signIn, signUp } = useAuth();
  const [mode, setMode] = useState<'in' | 'up'>('in');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    const r = mode === 'in' ? await signIn(email, password) : await signUp(email, password, fullName);
    setBusy(false);
    if (r.error) {
      toast.error(r.error);
      return;
    }
    if (mode === 'up') {
      toast.success('Conta criada. Verifique seu email se a confirmação estiver ativa.');
    }
    nav('/', { replace: true });
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-brand-50 via-white to-ink-50 p-6">
      <div className="card w-full max-w-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 grid place-items-center text-white">
            <Truck className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-ink-900">Roteirizador Kallas</h1>
            <p className="text-sm text-ink-500">Logística inteligente, semana após semana</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3">
          {mode === 'up' && (
            <div>
              <label className="label">Nome completo</label>
              <Input value={fullName} onChange={(e) => setFullName(e.target.value)} required />
            </div>
          )}
          <div>
            <label className="label">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="label">Senha</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>
          <Button type="submit" className="w-full" size="lg" disabled={busy}>
            {busy ? 'Aguarde…' : mode === 'in' ? 'Entrar' : 'Criar conta'}
          </Button>
        </form>

        <div className="mt-4 text-center">
          <button
            type="button"
            onClick={() => setMode((m) => (m === 'in' ? 'up' : 'in'))}
            className="text-sm text-brand-600 hover:text-brand-700 font-medium"
          >
            {mode === 'in' ? 'Não tem conta? Crie uma' : 'Já tem conta? Entre'}
          </button>
        </div>
      </div>
    </div>
  );
}
